import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const ScreenRenderer = lazy(() => import('./screen-renderer/screen-renderer.component'));
const WizardInitialisation = lazy(() => import('./wizard-initialisation/wizard-initialisation.component'));

export function WizardRoutes() {
    return (
        <Route path='wizard/:functionalityId'>
            <Route path=':wizardId'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <WizardInitialisation />
                        </AsyncComponent>
                    }
                />
                <Route path='screens'>
                    <Route
                        path=':screen_type'
                        element={
                            <AsyncComponent>
                                <ScreenRenderer />
                            </AsyncComponent>
                        }
                    />
                    <Route
                        index
                        element={<Navigate to='..' />}
                    />
                </Route>
            </Route>
        </Route>
    );
}
